import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Undo2 } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const UnconvertButton = ({ id, displayNo, testId, icon = false }) => {
  const nav = useNavigate();
  const run = async () => {
    if (!window.confirm(`Unconvert ${displayNo}? Penawaran (semua revisi & nego) diarsipkan dan kalkulasi dibuka lagi untuk diedit.`)) return;
    try {
      const { data } = await api.post(`/quotations/${id}/unconvert`);
      toast.success("Penawaran dikembalikan menjadi kalkulasi");
      nav(`/costings/${data.costing_id}`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return icon ? (
    <Button size="icon" variant="ghost" title="Unconvert ke Kalkulasi" onClick={run} data-testid={testId}><Undo2 className="h-4 w-4 text-violet-700" /></Button>
  ) : (
    <Button variant="outline" className="bg-white" onClick={run} data-testid={testId}><Undo2 className="h-4 w-4 mr-1 text-violet-700" />Unconvert</Button>
  );
};
